export const IMPRESSUM_SAVE = 'IMPRESSUM_SAVE'
export const IMPRESSUM_LOAD = 'IMPRESSUM_LOAD'
export const IMPRESSUM_SUCCESS = 'IMPRESSUM_SUCCESS'
export const IMPRESSUM_DEFAULT = 'IMPRESSUM_DEFAULT'
